// WelcomeModal.styles.js
export const modalStyles = {
  // Overlay styles
  overlay: {
    bg: "#26262680",
  },

  // Content styles
  content: {
    // borderRadius: "lg",
    maxW: "514px",
    w: "90%",
    p: 6,
    bg: "white",
    borderRadius: "15px",
  },

  lottieBox: {
    marginTop: "-30px",
    width: "240px",
    height: "204px",
    transition: "margin .5s",
  },

  lottieBoxMobile: {
    width: "240px",
    height: "204px",
    transition: "margin .5s",
    alignSelf: "center",
    top: "200px",
  },
  // Close button
  closeButton: {
    position: "absolute",
    top: 4,
    right: 4,
    size: "sm",
    variant: "ghost",
  },

  // Header section
  header: {
    mb: 6,
  },

  headerMobile: {
    mb: 6,
    h: "40%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  // Avatar
  avatar: {
    bg: "#5F4DC7",
    borderRadius: "full",
    w: "64px",
    h: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    mb: 4,
  },

  // Avatar eyes
  leftEye: {
    bg: "white",
    borderRadius: "full",
    position: "absolute",
    top: "8px",
    left: "16px",
    w: "24px",
    h: "24px",
  },

  rightEye: {
    bg: "white",
    borderRadius: "full",
    position: "absolute",
    top: "8px",
    right: "16px",
    w: "16px",
    h: "16px",
  },

  // Welcome text
  welcomeText: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px",
    alignItems: "center",
    marginTop: "-50px",
  },

  welcomeTextMobile: {
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "24px",
    marginBotton: "8px",
    alignItems: "center",
    color: "#251465",
  },

  // Content container
  contentContainer: {
    mb: 6,
  },

  contentContainerMobile: {
    mb: 6,
    mt: 6,
  },

  // Intro text
  introText: {
    fontSize: "16px",
    lineHeight: "22px",
    mb: 4,
    fontFamily: "Poppins",
    fontWeight: "400",
  },

  // List styles
  list: {
    mb: 4,
    mt: 4,
  },

  // List item
  listItem: {
    display: "flex",
    mb: 0,
  },

  // Bullet point
  bullet: {
    color: "#5F4DC7",
    mr: 2,
  },
  bulletMobile: {
    color: "#130159",
    mr: 2,
  },

  // List item text
  listItemText: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#5F4DC7",
  },

  listItemTextMobile: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#130159",
  },

  // Footer text
  footerText: {
    fontSize: "16px",
    lineHeight: "22px",
    fontFamily: "Poppins",
    fontWeight: "400",
  },

  // Button container
  buttonContainer: {
    justifyContent: "flex-end",
    gap: "12px",
  },
  buttonContainerMobile: {
    justifyContent: "flex",
    gap: "12px",
  },

  skipButton: {
    variant: "outline",
    w: "94px",
    h: "31px",
    borderRadius: "8px",
    p: 0,
    bg: "#F5F4FA",
    color: "#130159",
    fontWeight: "400",
    fontSize: "14px",
  },

  skipButtonMobile: {
    variant: "outline",
    h: "44px",
    w: "90%",
    display: "flex",
    borderRadius: "8px",
    p: 0,
    bg: "#F5F4FA",
    color: "#130159",
    fontWeight: "400",
    fontSize: "14px",
  },
  // Next button
  nextButton: {
    variant: "outline",
    w: "82px",
    h: "31px",
    borderRadius: "8px",
    p: 0,
    bg: "#5F4DC7",
    color: "#FFFFFF",
    fontWeight: "600",
    fontSize: "14px",
  },

  nextButtonMobile: {
    variant: "outline",
    h: "44px",
    w: "90%",
    borderRadius: "8px",
    p: 0,
    bg: "#5F4DC7",
    color: "#FFFFFF",
    fontWeight: "600",
    fontSize: "14px",
  },
};
